import { all, fork } from "redux-saga/effects";
import sessionRequestWatcher from "store/session/saga";
import portalConfigWatcher from "store/portal/saga";

export default function* root() {
  yield all([fork(sessionRequestWatcher), fork(portalConfigWatcher)]);
}
